<template>
  <v-row>
    <v-col>
      <v-col class="d-flex justify-space-between mx-auto flex-wrap container">
        <ToolbarTitles :title="title" />
        <ButtonsCardList @cardView="cardView" />
      </v-col>
      <div v-show="showCard" class="container">
        <CardsView
          :items="cards"
          :openDialog="openDialog"
          @refreshItems="refreshItems"
          :showRefresh="true"
        />
      </div>
      <div v-show="!showCard" class="container">
        <TableWithSearch
          :items="cards"
          :headers="allHeaders"
          :openDialog="openDialog"
          :showPagination="false"
          @headersUpdated="updateHeaders"
          @refreshItems="refreshItems"
          :showRefresh="true"
        />
      </div>
      <v-pagination
        v-if="cards?.length > 0"
        v-model="currentPage"
        :length="totalPages"
        prev-icon="mdi-chevron-left"
        next-icon="mdi-chevron-right"
        hide-delimiter-background
        :items-per-page="limit"
        @input="changePage"
      />
      <v-dialog
        v-model="open"
        :fullscreen="mode === $tc('cards.editCard')"
        :max-width="maxWidth[0]"
        hide-overlay
        persistent
        @keydown.esc="reset(false)"
      >
        <FormCard
          :key="formKey"
          :items="dataInputs"
          @save="saveForm"
          @cancel="reset"
          @force-form="forceForm"
          :maxWidth="maxWidth[0]"
          :mode="mode"
          :show="true"
          :itemsCheckbox="dataCheckboxes"
        />
      </v-dialog>

      <DeleteDialog
        :showDialog="openDelete"
        :title="titleDelete"
        :confirmDelete="deleteItem"
        :cancelDelete="cancelDelete"
        :maxWidth="maxWidth[2]"
      />
    </v-col>
    <v-dialog v-model="isLoading" class="dialog__loader" :overlay-opacity="0.3">
      <Loader :loading="isLoading" />
    </v-dialog>
    <Snackbar :alert="alert" :color="color" :textAlert="textAlert" />
  </v-row>
</template>
<script>
import date from "@/store/common/date";
import cards from "../../../store/tarjetas/cards";
import FormCard from "./Form/FormCard.vue";
import concepts from "@/store/conceptos/concepts";
import salariesConcepts from "../../../store/conceptosDeSueldos/salaryConcepts";
import CardsView from "./Card.vue";
import TableWithSearch from "./Table.vue";
import ToolbarTitles from "@/components/Complement/ToolbarTitles.vue";
import ButtonsCardList from "@/components/Complement/ButtonsCardList.vue";
import DeleteDialog from "@/components/Complement/DeleteDialog.vue";
import Snackbar from "@/components/Complement/Snackbar.vue";
import Loader from "@/components/Complement/Loader.vue";
import configTable from "@/store/configuracionDeTablas/configTable.js";

export default {
  components: {
    FormCard,
    TableWithSearch,
    CardsView,
    ToolbarTitles,
    ButtonsCardList,
    DeleteDialog,
    Snackbar,
    Loader,
  },
  data() {
    return {
      title: this.$tc("nav.cards"),
      titleTable: "Tarjetas_y_Relaciones",
      titleDelete: this.$tc("cards.toCard"),
      isLoading: true,
      oldItems: null,
      maxWidth: ["600px", "500px", "400px"],
      color: "#82A1D0",
      alert: false,
      textAlert: "",
      showCard: true,
      itemId: null,
      oldItems: null,
      dataInputs: null,
      formKey: 0,
      dataInputsEdit: [
        {
          name: "cardNumber",
          label: "numero de tarjeta",
          data: "",
          type: "chart",
          rules: [
            (v) => !!v || this.$tc("editRegistrations.requerid"),
            (v) => {
              if (v.length > 36) {
                return this.$tc("validation.maxChart", 36, { max: 36 });
              }

              const alphaNumericMatch = v.match(/^([a-zA-Z]+)(\d+)?$/);

              if (alphaNumericMatch) {
                const [, letters, numbers] = alphaNumericMatch;
                if (numbers && isNaN(numbers)) {
                  return this.$tc("validation.invalidFormat");
                }
              } else {
                const numericMatch = v.match(/^\d+$/);
                if (!numericMatch) {
                  return this.$tc("validation.invalidFormat");
                }
              }
              return true;
            },
          ],
        },
        {
          name: "comment",
          label: this.$tc("cards.comment"),
          data: "",
          type: "text",
          rules: [],
        },
      ],
      dataInputsAdd: [
        {
          name: "startValue",
          label: this.$tc("cards.startValue"),
          data: "",
          type: "chart",
          rules: [
            (v) => !!v || this.$tc("editRegistrations.requerid"),
            (v) => {
              if (v.length > 36) {
                return this.$tc("validation.maxChart", 36, { max: 36 });
              }

              const alphaNumericMatch = v.match(/^([a-zA-Z]+)(\d+)?$/);

              if (alphaNumericMatch) {
                const [, letters, numbers] = alphaNumericMatch;
                if (numbers && isNaN(numbers)) {
                  return this.$tc("validation.invalidFormat");
                }
              } else {
                const numericMatch = v.match(/^\d+$/);
                if (!numericMatch) {
                  return this.$tc("validation.invalidFormat");
                }
              }

              return true;
            },
          ],
        },

        {
          name: "quantity",
          label: this.$tc("cards.numberOfCards"),
          data: "",
          type: "number",
          rules: [
            (v) => !!v || this.$tc("editRegistrations.requerid"),
            (v) =>
              /^(?:[1-9][0-9]{0,2}|1000)$/.test(v) ||
              this.$t("validation.range", { min: 1, max: 1000 }),
          ],
        },

        {
          name: "comment",
          label: this.$tc("cards.comment"),
          data: "",
          type: "text",
          rules: [
            (v) =>
              v.length <= 100 ||
              this.$tc("validation.maxChart", 100, { max: 100 }),
          ],
        },
      ],
      dataCheckboxes: null,
      dataCheckboxesEdit: [
        {
          name: "active",
          label: "Habilitada",
          data: false,
        },
      ],
      headers: {
        tarjetas: [
          {
            text: "Tarjeta",
            value: "name",
            class: "primary secondary--text",
            visible: true,
          },
          {
            text: "Comentario",
            value: "comment",
            class: "primary secondary--text",
            visible: true,
          },
          {
            text: "Habilitada",
            value: "activeTable",
            class: "primary secondary--text",
            visible: true,
          },
          {
            text: "Acciones",
            value: "actions",
            class: "primary secondary--text",
            visible: true,
            sortable: false,
            width: "100px",
          },
        ],
        operadores: [
          {
            text: "Nombre",
            value: "empNombre",
            class: "primary secondary--text",
            visible: true,
          },
          {
            text: "Desde",
            value: "fecDesde",
            class: "primary secondary--text",
            visible: true,
            sortable: false,
          },
          {
            text: "Hasta",
            value: "fecHasta",
            class: "primary secondary--text",
            visible: true,
            sortable: false,
          },
          {
            text: "Acciones",
            value: "actions",
            class: "primary secondary--text",
            visible: true,
            sortable: false,
            width: "100px",
          },
        ],
      },
    };
  },
  mounted() {
    this.isLoading = true;
    try {
      const nameTable = this.titleTable;
      const columnPromise = configTable
        .dispatch("getColumsTableName", nameTable)
        .then(() => {
          if (
            configTable.state.colums.length === 0 ||
            Object.values(this.allColums).reduce(
              (sum, array) => sum + array.length,
              0
            ) !==
              Object.values(this.headers).reduce(
                (sum, array) => sum + array.length,
                0
              )
          ) {
            this.saveConfigColumns();
          }
        })
        .catch((error) => {
          console.error("Error loading columns:", error);
        });
      const cardsPromise = cards.dispatch("getCards");
      Promise.all([columnPromise, cardsPromise]).then(() => {
        this.isLoading = false;
      });
    } catch (error) {
      this.isLoading = false;
      this.showAlert(this.$t("validation.fetchData"));
    }
  },
  computed: {
    allHeaders() {
      return Array.isArray(configTable.state?.colums.tarjetas)
        ? configTable.state.colums.tarjetas
        : [];
    },
    allColums() {
      return configTable.state.colums;
    },
    cards() {
      return cards.state.cards;
    },
    currentPage: {
      get() {
        return cards.state.currentPage;
      },
      set(value) {
        cards.state.currentPage = value;
      },
    },
    totalPages() {
      return cards.getters.totalPages;
    },
    limit() {
      return cards.state.limit;
    },
    padding() {
      return salariesConcepts.state.paddingNav;
    },
    concepts() {
      return concepts.state.concepts;
    },
    mode: {
      get() {
        return cards.state.mode;
      },
      set(newValue) {
        return newValue;
      },
    },
    open: {
      get() {
        return cards.state.open;
      },
      set(newvalue) {
        return newvalue;
      },
    },
    openDelete: {
      get() {
        return cards.state.openDelete;
      },
      set(newvalue) {
        return newvalue;
      },
    },
  },
  methods: {
    async refreshItems() {
      await cards.dispatch("getCards");
    },
    async changePage(page) {
      this.isLoading = true;
      await cards.dispatch("updatePage", page);
      this.isLoading = false;
    },

    updateHeaders(headers) {
      const updatedColums = { ...configTable.state.colums, tarjetas: headers };

      configTable.commit("setColums", updatedColums);
      this.saveConfigColumns();
    },

    saveConfigColumns() {
      let columnsToSave = configTable.state.colums;
      if (
        columnsToSave === undefined ||
        Object.values(this.allColums).reduce(
          (sum, array) => sum + array.length,
          0
        ) !==
          Object.values(this.headers).reduce(
            (sum, array) => sum + array.length,
            0
          ) ||
        columnsToSave.length === 0
      ) {
        columnsToSave = this.headers;
      }

      const configData = {
        operId: Number(localStorage.getItem("operId")),
        nameTable: this.titleTable,
        json: JSON.stringify(columnsToSave),
      };
      configTable.commit("setNew", configData);
      configTable.dispatch("new").then(() => {
        configTable.commit("setNew", []);
      });
    },
    async generateCard(form) {
      const startValue = form.startValue;
      const quantity = parseInt(form.quantity);
      const comment = form.comment || null;

      const numericValue = parseInt(startValue.match(/\d+/)[0]);
      const paddingLength = startValue.length;

      const cards = Array.from({ length: quantity }, (_, index) => {
        const cardNumber = (numericValue + index)
          .toString()
          .padStart(paddingLength, "0"); // Añadir ceros a la izquierda
        return {
          numTarj: `${startValue.replace(/\d+/, cardNumber)}`, // Reemplazar en el formato original
          comentario: comment,
        };
      });

      return { cards };
    },

    async addCards(form) {
      this.isLoading = true;

      try {
        const payload = await this.generateCard(form);

        cards.commit("setNew", payload);
        await cards.dispatch("addCards");
        this.isLoading = false;
        this.alert = true;
        this.textAlert = this.$tc("cards.addCardsSuccess");
      } catch (error) {
        this.isLoading = false;
        this.alert = true;
        this.textAlert = this.$tc("cards.errorCard");
        this.color = "#ff8d58";
      }
      this.reset(false);
    },
    async editCard(form) {
      let payload = this.detectChanges(form);
      if (payload.hasOwnProperty("active")) {
        payload.active = payload.active ? "S" : "N";
      }

      if (Object.keys(payload).length > 0) {
        payload.id = this.oldItems.id;
        cards.commit("setEdit", payload);
        cards
          .dispatch("editCard")
          .then(() => {
            this.showAlert(this.$tc("cards.editCardSuccess"), "#82A1D0");
          })
          .catch((e) => {
            this.showAlert(this.$tc("cards.errorCard"), "#ff8d58");
          });
      } else {
        this.showAlert(this.$tc("validation.noEditsMessage"), "#F7DC6F");
      }

      this.reset(false);
    },
    detectChanges(newItems) {
      const changes = {};
      const oldItem = this.oldItems;

      if (newItems.active === undefined) {
        newItems.active = false;
      }
      if (newItems.active === "true") {
        newItems.active = true;
      }
      if (newItems.comment === "") {
        newItems.comment = null;
      }

      if (oldItem.activeBool !== newItems.active) {
        changes.active = newItems.active;
      }

      if (oldItem.name !== newItems.cardNumber) {
        changes.cardNumber = newItems.cardNumber;
      }

      if (oldItem.comment !== newItems.comment) {
        changes.comment = newItems.comment;
      }

      return changes;
    },
    showAlert(text, color) {
      this.alert = true;
      this.textAlert = text;
      this.color = color;

      setTimeout(() => {
        this.alert = false;
      }, 3000);
    },

    saveForm(items) {
      switch (this.typeForm) {
        case "add":
          this.addCards(items);
          break;
        case "edit":
          this.editCard(items);
          break;
        default:
          break;
      }
    },
    resetDate() {
      const day = new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10);
      date.commit("setDateFrom", day);
      date.commit("setDateTo", null);
    },
    reset(value) {
      this.resetDate();
      cards.commit("setOpen", value);
      this.dataInputs = null;
      this.dataCheckboxes = null;
    },
    forceForm() {
      this.formKey++;
    },
    cardView(value) {
      this.showCard = value;
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      const year = date.getUTCFullYear();
      const month = String(date.getUTCMonth() + 1).padStart(2, "0");
      const day = String(date.getUTCDate()).padStart(2, "0");

      return `${day}-${month}-${year}`;
    },
    async setEdit(item) {
      this.dataInputs[0].data = item.name;
      this.dataInputs[1].data = item.comment;
      this.dataCheckboxes[0].data = item.activeBool;
      cards.commit("setOpen", true);
    },
    async openDialog(type, item) {
      this.typeForm = type;
      switch (this.typeForm) {
        case "add":
          this.dataInputs = this.dataInputsAdd;
          this.dataCheckboxes = null;
          cards.commit("setMode", this.$tc("cards.addCard"));
          cards.commit("setOpen", true);
          this.formKey++;
          break;
        case "edit":
          this.dataInputs = this.dataInputsEdit;
          this.oldItems = item;
          this.dataCheckboxes = this.dataCheckboxesEdit;
          this.oldItems = item;
          this.itemId = item.id;
          await cards.dispatch("getCardData", this.itemId);
          cards.commit("setMode", this.$tc("cards.editCard"));
          await this.setEdit(cards.state.edit);
          this.formKey++;
          break;
        case "delete":
          cards.commit("setOpenDelete", true);
          this.itemToDelete = item.id;
          break;
        default:
          break;
      }
    },

    deleteItem() {
      cards.commit("setItemDelete", this.itemToDelete);
      cards
        .dispatch("deleteCard")
        .then(() => {
          this.openDelete = false;
          cards.commit("setOpenDelete", false);
          this.alert = true;
          this.textAlert = this.$tc("cards.deleteCardSuccess");
        })
        .catch((e) => {
          this.alert = true;
          this.textAlert = this.$tc("cars.errorCard");
          this.color = "#ff8d58";
        });
    },

    cancelDelete() {
      this.openDelete = false;
      cards.commit("setOpenDelete", false);
    },
  },
};
</script>
<style>
.container {
  max-width: 100%;
  padding-top: 1vh;
  padding-bottom: 1vh;
}
</style>
